export default __webpack_public_path__ + "static/hero-news-4e32669ead67874a5a1a688d0143e3fb.jpg";